import { useEffect } from 'react';
import CardDisplay from '../CardDisplay';

/** The sales page is the home page for signed-out visitors; signup with a plan lives at /start. */
export const SALES_HOME = '/';
export const SIGNUP_BASE = '/start';
/** Old secret preview address, kept only to redirect people who bookmarked it. */
export const OLD_PREVIEW_BASE = '/preview-3b12b5859741';
export const signupPath = (plan = 'free', interval = 'month') => `${SIGNUP_BASE}?plan=${plan}&interval=${interval}`;

/** Sets the page title while mounted. */
export function usePageTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    return () => { document.title = prevTitle; };
  }, [title]);
}

/* Sample people for the demo. Fictional names, 555 numbers and example.com addresses. */
export const SAMPLE_CARD = {
  id: 'sample',
  slug: 'sample',
  full_name: 'Daniela Reyes',
  title: 'Commercial Real Estate Advisor',
  company: 'Reyes Property Group',
  department: 'Brickell office',
  phone: '(305) 555-0142',
  email: 'daniela@example.com',
  website: 'https://example.com',
  linkedin: 'https://linkedin.com/in/example',
  photo_url: '/sales/sample-portrait.svg',
};
export const SAMPLE_THEME = { primary_color: '#0B1530', accent_color: '#265EE6' };

export const TEAM_THEME = { primary_color: '#1D4CC2', accent_color: '#0B1530', layout: 'classic', locked_fields: ['layout'] };
const team = { company: 'Northline Freight', website: 'https://example.com' };
export const TEAM_CARDS = [
  { ...team, id: 't1', full_name: 'Marcus Bell', title: 'Account Executive', phone: '(305) 555-0188', email: 'marcus@example.com' },
  { ...team, id: 't2', full_name: 'Priya Nair', title: 'Operations Lead', phone: '(305) 555-0123', email: 'priya@example.com' },
  { ...team, id: 't3', full_name: 'Tom Alvarez', title: 'Fleet Manager', phone: '(305) 555-0167', email: 'tom@example.com' },
];

/**
 * A real CardDisplay drawn at phone width (360px) and scaled, inside a navy phone outline.
 * It is a picture of the product, so its links and buttons are not focusable or clickable.
 */
export function MiniPhone({ card, theme, layout, scale = 0.5, height = 720, className = '' }) {
  const w = 360;
  return (
    <div className={`bg-navy rounded-[28px] p-2 shadow-[0_18px_40px_-12px_rgba(11,21,48,0.45)] shrink-0 ${className}`}
      style={{ width: w * scale + 16 }} aria-hidden="true">
      <div className="rounded-[21px] overflow-hidden bg-white relative" style={{ width: w * scale, height: height * scale }}>
        <div className="pointer-events-none select-none origin-top-left absolute left-0 top-0" style={{ width: w, height, transform: `scale(${scale})` }}
          ref={(el) => el && el.setAttribute('inert', '')}>
          <CardDisplay card={card} theme={theme} layout={layout} className="h-full [&>div]:min-h-full" />
        </div>
      </div>
    </div>
  );
}

export function Check({ className = 'text-blue' }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" className={`shrink-0 mt-[3px] ${className}`}><path d="m5 12 4.5 4.5L19 7" /></svg>
  );
}

export function SoonTag({ dark = false }) {
  return (
    <span className={`inline-flex items-center h-6 px-2.5 rounded-full text-[12px] font-semibold whitespace-nowrap ${dark ? 'bg-white/15 text-white' : 'bg-coral-soft text-coral-ink'}`}>
      Coming soon
    </span>
  );
}
